export default ({ request }) => ({
  materialInspectionListApi(data = {}) {
    return request({
      url: '/factory/material/inspection/list',
      method: 'post',
      data
    })
  },
  materialInspectionDetailApi(data = {}) {
    return request({
      url: '/factory/material/inspection/detail',
      method: 'post',
      data
    })
  },
  materialInspectionDelApi(data = {}) {
    return request({
      url: '/factory/material/inspection/del',
      method: 'post',
      data
    })
  },
  materialInspectionPcSaveApi(data = {}) {
    return request({
      url: '/factory/material/inspection/pcSave',
      method: 'post',
      data
    })
  },
  materialInspectionSubmitApi(data = {}) {
    return request({
      url: '/factory/material/inspection/submit',
      method: 'post',
      data
    })
  },
  materialInspectionSaveApi(data = {}) {
    return request({
      url: '/factory/material/inspection/save',
      method: 'post',
      data
    })
  },
  materialInspectionSubmitAndSaveApi(data = {}) {
    return request({
      url: '/factory/material/inspection/submitAndSave',
      method: 'post',
      data
    })
  },
  materialInspectionListByInventoryApi(data = {}) {
    return request({
      url: '/factory/material/inspection/listByInventory',
      method: 'post',
      data
    })
  },
  materialInspectionSaveByInventoryApi(data = {}) {
    return request({
      url: '/factory/material/inspection/saveByInventory',
      method: 'post',
      data
    })
  },
  materialInspectionSaveAndSubmitByInventoryApi(data = {}) {
    return request({
      url: '/factory/material/inspection/saveAndSubmitByInventory',
      method: 'post',
      data
    })
  },
  materialInspectionReviewApi(data = {}) {
    return request({
      url: '/factory/material/inspection/review',
      method: 'post',
      data
    })
  }
})
